export const PASSWORD_EXPIRY_DEADLINE = "2026-11-04";

const [, deadlineMonth, deadlineDay] = PASSWORD_EXPIRY_DEADLINE.split("-");

export const PASSWORD_EXPIRY_DEADLINE_LABEL = `${deadlineDay}/${deadlineMonth}`;

const ARGENTINA_TIME_ZONE = "America/Argentina/Buenos_Aires";

/**
 * Today's date in Argentina as `YYYY-MM-DD`, regardless of the device's time zone.
 * @param {Date} now
 * @returns {string}
 */
export const argentinaDate = (now) =>
  now.toLocaleDateString("en-CA", { timeZone: ARGENTINA_TIME_ZONE });

/**
 * Whether the password expiry notice is still shown: up to the day before the deadline, inclusive.
 * @param {Date} now
 * @returns {boolean}
 */
export const isBeforePasswordExpiryDeadline = (now = new Date()) =>
  argentinaDate(now) < PASSWORD_EXPIRY_DEADLINE;
